<template>
<div class="fullWidth fRow jBetween aStart">
  <div class="addQuestion fRow jBetween aStart wrap growFull">
    <h2 class="fullWidth fRow jStart aCenter" v-if="mode === 'edit'">
      <i class="material-icons-round">edit</i>
      فرم ویرایش {{init.title}}
    </h2>
    <div class="fullWidth fRow jBetween aStart wrap">
      <!-- عنوان آزمون -->
      <div class="w75 fCol jStart aStart inputWraper">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round">school</i>
          عنوان آزمون</span>
        <textarea class="transition-fast" style="height: 108px"
          placeholder="عنوان آزمون"
          type="text"
          v-model="examName"></textarea>
      </div>
      <!-- مدت زمان -->
      <div class="w25 fCol jStart aStart inputHolder">
        <div class="fCol jStart aStart fullWidth inputWraper">
          <span class="fRow jStart aCenter">
            مدت آزمون (دقیقه)</span>
          <input class="transition-fast"
            placeholder="مدت آزمون"
            type="number"
            v-model.lazy="examDuration">
        </div>
      </div>
      <div class="w33 fRow jBetween aStart inputHolder"
        @click="examIsSync = !examIsSync"
        style="">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round"
            v-bind:class="{inpErr: true}">sync</i>
          نوع آزمون</span>
        <switch-button
          activeLabel='هماهنگ'
          deactiveLabel='غیرهماهنگ'
          :monocolor="true"
          :val="examIsSync" />
      </div>
      <div class="sepline"></div>
      <div class="w33 fRow jBetween aStart inputHolder"
        @click="examIsRandomQuestion = !examIsRandomQuestion"
        style="">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round"
            v-bind:class="{inpErr: true}">low_priority</i>
          ترتیب سؤال</span>
        <switch-button
          :monocolor="true"
          activeLabel='به ترتیب'
          deactiveLabel='تصادفی'
          :val="examIsRandomQuestion" />
      </div>
      <div class="sepline"></div>
      <div class="w33 fRow jBetween aStart inputHolder"
        @click="examSkipOnTime = !examSkipOnTime"
        style="">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round"
            v-bind:class="{inpErr: true}">hourglass_empty</i>
          زمان هر سؤال</span>
        <switch-button
          :monocolor="true"
          activeLabel='آزاد'
          deactiveLabel='محدود'
          :val="examSkipOnTime" />
      </div>
      <div class="previewInfos fRow jBetween aCenter w75"
        v-if="mode === 'edit' && (mode === 'edit' && !editFieldGradeLesson)">
        <div class="w33 fCol jCenter aStart inputHolder">
          <span>رشته‌ی تحصیلی</span>
          <label class="fCol jCenter aStart">
            {{sayFieldName(init.field)}}
          </label>
        </div>
        <div class="w33 fCol jCenter aStart inputHolder">
          <span>پایه‌ی تحصیلی</span>
          <label class="fCol jCenter aStart">
            {{init.gradeName}}
          </label>
        </div>
        <div class="w33 fCol jCenter aStart inputHolder">
          <span>درس</span>
          <label class="fCol jCenter aStart" v-if="init.lessonId !== null">
            {{init.lessonName}}
          </label>
          <label class="fCol jCenter aStart" v-if="init.lessonId === null">
            آزمون جامع
          </label>
        </div>
        <div class="openEditor fCol jCenter aCenter transition-fast"
          @click="editFieldGradeLesson = true">
          <i class="material-icons-round">edit</i>
          <div class="dialog">ویرایش اطلاعات</div>
        </div>
      </div>
      <div class="fRow jBetween aStart w75" style="margin: 16px 0"
        v-if="mode === 'add' || (mode === 'edit' && editFieldGradeLesson)">
        <div class="inputHolder w33 fRow jStart aCenter">
          <div class="ih fullWidth fCol jStart aStart">
            <span>انتخاب رشته</span>
            <cool-select
              class="fullWidth"
              @select="selected($event, 'field')"
              v-model="examField"
              disable-search
              :items="fields"
              :item-value="fields.id"
              :item-text="fields.title">
              <!-- slot for each item in the menu -->
              <template slot="item" slot-scope="{ item: field }">
                <div style="display: flex; align-items: center;">
                  <div>
                    {{ field.title }}
                  </div>
                </div>
              </template>
              <!-- slot for the selected item (in the text field) -->
              <template slot="selection" slot-scope="{ item: field }">
                <div>
                  {{ field.title }}
                </div>
              </template>
            </cool-select>
          </div>
        </div>
        <div class="inputHolder w33 fRow jStart aCenter">
          <div class="ih fullWidth fCol jStart aStart">
            <span>انتخاب پایه</span>
            <cool-select
              class="fullWidth"
              @select="selected($event, 'grade')"
              v-model="examGrade"
              disable-search
              :items="grades"
              :item-value="grades.id"
              :item-text="grades.title">
              <!-- slot for each item in the menu -->
              <template slot="item" slot-scope="{ item: grade }">
                <div style="display: flex; align-items: center;">
                  <div>
                    {{ grade.title }}
                  </div>
                </div>
              </template>
              <!-- slot for the selected item (in the text field) -->
              <template slot="selection" slot-scope="{ item: grade }">
                <div>
                  {{ grade.title }}
                </div>
              </template>
            </cool-select>
          </div>
        </div>
        <div class="inputHolder w33 fRow jStart aCenter">
          <div class="ih fullWidth fCol jStart aStart">
            <span>انتخاب درس</span>
            <cool-select
              class="fullWidth"
              @select="selected($event, 'lesson')"
              v-model="examLesson"
              disable-search
              :items="lessons"
              :item-value="lessons.id"
              :item-text="lessons.title">
              <!-- slot for each item in the menu -->
              <template slot="item" slot-scope="{ item: lesson }">
                <div style="display: flex; align-items: center;">
                  <div>
                    {{ lesson.title }}
                    <b>{{ lesson.value }}</b>
                  </div>
                </div>
              </template>
              <!-- slot for the selected item (in the text field) -->
              <template slot="selection" slot-scope="{ item: lesson }">
                <div>
                  {{ lesson.title }}
                  <b>{{ lesson.value }}</b>
                </div>
              </template>
            </cool-select>
          </div>
        </div>
      </div>
      <!-- دفعات شرکت در آزمون -->
      <div class="w25 fCol jStart aStart inputHolder" style="margin: 16px 0">
        <span class="fRow jStart aCenter">
          دفعات شرکت در آزمون</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <input class="transition-fast"
            :disabled="examIsSync"
            placeholder="دفعات شرکت در آزمون"
            type="number"
            v-model="examHowManyTimes">
        </div>
      </div>
      <date-picker
        v-model="examDate"
        :jumpMinute="15"
        :roundMinute="true"
        :min="today"
        type="datetime"
        element="examDate">
      </date-picker>
      <div class="w33 fCol jStart aStart"
        style="margin-left: 12px"
        v-if="examIsSync">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round"
            v-bind:class="{inpErr: true}">date_range</i>
          تاریخ و ساعت شروع آزمون</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <input @keyup.enter="newAssignment" id="examDate"
            disabled
            class="transition-fast" placeholder="تاریخ آزمون"
            type="text" v-model="examDateShow">
        </div>
        <span v-if="examDateShow.length > 0">تا ساعت {{endAtShow}}</span>
      </div>
      <!-- توضیحات آزمون -->
      <div class="growFull fCol jStart aStart"
        style="margin-bottom: 0;">
        <span class="fRow jStart aCenter"><i class="material-icons-round">description</i>
          توضیحات آزمون</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <textarea @keyup.enter="newAssignment"
            style="height: 88px"
            class="transition-fast" placeholder="توضیحات آزمون"
            type="text" v-model="examDesc"></textarea>
        </div>
      </div>
    </div>
    <!-- لیست سؤالات اضافه شده به آزمون -->
    <div class="fullWidth examQuestionList fRow jBetween aStart wrap">
      <h4 class="fRow jStart aCenter fullWidth">
        <div class="growFull">لیست سؤالات اضافه شده به آزمون</div>
        <div class="b fRow jStart aCenter"
          v-if="examQuestions.length > 0 && !examActiveNumbering"
          @click="clearSelected">
          <i class="material-icons-round">delete</i>
          <label>حذف سؤالات</label>
        </div>
      </h4>
      <p>لطفا ابتدا تمام سؤالات مربوط به آزمون را انتخاب کنید، پس از نهایی شدن
        لیست سؤالات برای شماره‌دهی به سؤالات اقدام کنید.
      </p>
      <div class="noQ fullWidth fCol jCenter aStart"
        v-if="examQuestions.length === 0">
        <span>شما هنوز سؤالی برای آزمون انتخاب نکرده‌اید</span>
        <span class="m">لیست سؤالات را فیلتر کنید و به آزمون اضافه کنید</span>
      </div>
      <ul class="fullWidth" v-if="examQuestions.length > 0">
        <li class="fRow jStart aCenter"
          v-for="(item, index) in examQuestions" v-bind:key="index">
          <input type="number"
            :value="index + 1"
            :id="`qIndex${index}`"
            placeholder="شماره سؤال"
            :disabled="!examActiveNumbering">
          <div class="qQuestion growFull fCol jStart aStart">
            <div class="fullWidth fRow jStart aCenter">
              <i class="material-icons-round hard" title="سؤال سخت"
                v-if="item.level === 'hard'">sentiment_neutral</i>
              <i class="material-icons-round normal" title="سؤال معمولی"
                v-if="item.level === 'normal'">sentiment_satisfied</i>
              <i class="material-icons-round easy" title="سؤال آسان"
                v-if="item.level === 'easy'">sentiment_very_satisfied</i>
              <!-- <span class="q">{{item.title}}</span> -->
              <quill-editor ref="myTextEditor"
                class="fullWidth qlClass"
                v-model="item.title"
                :disabled="true"
                :options="qItemQuillOptions"></quill-editor>
            </div>
            <div class="fRow jStart aCenter" style="margin-top: 16px">
              <div class="b lesson fRow jStart aCenter mini"
                @click="bankSelectedLesson = item.lesson">
                <i class="material-icons-round">menu_book</i>
                <label>{{item.lesson}}</label>
              </div>
              <div class="b lesson fRow jStart aCenter mini">
                <i class="material-icons-round">category</i>
                <label>{{item.field}}</label>
              </div>
              <div class="b lesson fRow jStart aCenter mini">
                <i class="material-icons-round">toc</i>
                <label>{{item.grade}}</label>
              </div>
            </div>
          </div>
          <div class="b fRow fab" @click="deleteQuestion(item.id)"
            v-if="!examActiveNumbering">
            <i class="material-icons-round">delete</i>
          </div>
        </li>
      </ul>
    </div>
    <!-- دکمه ها برای حالت اضافه کردن آزمون -->
    <div class="fRow jStart aCenter fullWidth"
      style="margin: 16px 0">
      <div class="b fRow jStart aCenter big active"
        v-if="examIsRandomQuestion && !examActiveNumbering"
        @click="calcIsolateMode('on')"
        v-bind:class="{disabled: !isFormReady}">
        <label>مرحله‌ی بعد > ثبت شماره سؤالات</label>
      </div>
      <!-- ████████ -->
      <div class="b fRow jStart aCenter big"
        @click="newExam"
        v-if="(!examIsRandomQuestion || examActiveNumbering) && mode === 'add'"
        v-bind:class="{active: isFormReady}">
        <i class="material-icons-round">add</i>
        <label>ایجاد آزمون</label>
      </div>
      <div class="b fRow jStart aCenter big"
        @click="editExam"
        v-if="(!examIsRandomQuestion || examActiveNumbering) && mode === 'edit'"
        v-bind:class="{active: isFormReady}">
        <i class="material-icons-round">add</i>
        <label>ثبت تغییرات آزمون</label>
      </div>
      <div class="b fRow jStart aCenter"
        v-if="examActiveNumbering"
        @click="calcIsolateMode('off')">
        <i class="material-icons-round">edit</i>
        <label>ویرایش سؤالات</label>
      </div>
      <div class="b fRow jStart aCenter mini" @click="clearExam">
        <i class="material-icons-round">delete</i>
        <label>پاک کردن فرم</label>
      </div>
    </div>
  </div>
  <question-bank @nq="addNewnQuestion" from="add"/>
</div>
</template>

<script>
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import { CoolSelect } from 'vue-cool-select';
import SwitchButton from '@/components/SwitchButton.vue';
import { EventBus } from '@/plugins/event-bus';
import moment from 'moment-jalaali';
import QuestionBank from '@/components/QuestionBank.vue';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import katex from 'katex';
import 'katex/dist/katex.min.css';

export default {
  mixins: [errorHandler, makeToast],
  props: ['mode', 'init'],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      qItemQuillOptions: {
        placeholder: 'متن گزینه را وارد کنید',
        theme: 'bubble',
        modules: {
          toolbar: [
            ['formula', 'clean'],
            ['bold', 'underline'],
            [{ color: [] }, { background: [] }],
          ],
        },
      },
      editFieldGradeLesson: false,
      today: '',
      isolateMode: false,
      fields: [
        {
          id: '',
          title: 'حذف فیلتر',
        },
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'زبان',
        },
        {
          id: 6,
          title: 'هنر',
        },
      ],
      fFieldIdErr: true,
      grades: [
        {
          id: '',
          title: 'لطفا رشته را انتخاب کنید',
        },
      ],
      fGradeErr: true,
      lessons: [
        {
          id: '',
          title: 'ابتدا رشته را انتخاب کنید',
        },
      ],
      fLessonErr: true,
      filterLesson: '',
      // add exam
      examName: '',
      eNameErr: true,
      eNameLen: 112,
      examIsSync: false,
      examField: '',
      eField: 0,
      eFieldErr: true,
      examGrade: '',
      eGrade: '',
      isGradesLoaded: false,
      eGradeErr: true,
      examDate: '',
      examDateShow: '',
      eDateErr: true,
      examStartAt: '',
      eStartAtErr: true,
      examEndAt: '',
      eEndAtErr: true,
      endAtShow: '',
      examLesson: '',
      examDuration: 5,
      examHowManyTimes: 1,
      examIsRandomQuestion: false,
      examSkipOnTime: false,
      examDesc: '',
      eDescLen: 512,
      eDescErr: true,
      examQuestions: [],
      eQuestionIds: [],
      examActiveNumbering: false,
    };
  },
  components: {
    CoolSelect,
    SwitchButton,
    QuestionBank,
    quillEditor,
  },
  methods: {
    addNewnQuestion(e) {
      for (let i = 0; i < e.length; i += 1) {
        this.examQuestions.push(e[i]);
      }
      // if (this.findInArray(e.id) === -1) {
      // } else {
      //   this.makeToast('warning', 'این سؤال قبلا اضافه شده است', 3000);
      // }
    },
    // dynamic fields
    getFields() {
      this.fields = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        const f = response.data.data;
        if (response.data.isSuccess) {
          if (f.length === 0) {
            this.examGrade = {};
            this.examLesson = {};
            this.grades = [
              {
                id: -1,
                title: 'ابتدا رشته را انتخاب کنید',
              },
            ];
            this.lesson = [
              {
                id: -1,
                title: 'ابتدا رشته را انتخاب کنید',
              },
            ];
            this.fields = [
              {
                id: -1,
                title: 'هیچ رشته‌ای ثبت نشده',
              },
            ];
          } else {
            // this.classGradeErr = true;
            this.examGrade = {};
            // this.classLessonErr = true;
            this.examLesson = {};
            this.fields = [];
            for (let i = 0; i < f.length; i += 1) {
              const item = {
                id: f[i].id,
                title: f[i].title,
              };
              this.fields.push(item);
            }
            // console.log('addExamFields:', f);
            // خالی نیست
          }
        } else {
          this.makeToast('error', 'خطا در دریافت رشته‌ها', 3000);
          this.classFields = [
            {
              id: -1,
              title: 'خطا در دریافت رشته‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.classFields = [
          {
            id: -1,
            title: this.errorHandler(error),
          },
        ];
      });
    },
    getGrades(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Grades`;
      if (f !== -1) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      } else {
        return;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.grades = [];
          const arr = response.data.data;
          this.grades.push({
            id: '',
            title: 'حذف فیلتر',
          });
          for (let i = 0; i < arr.length; i += 1) {
            this.grades.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
          // console.warn(this.grades);
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getExamQuestions() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Exams/questions/${this.init.id}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          const bank = response.data.data;
          // console.warn(bank);
          for (let i = 0; i < bank.length; i += 1) {
            const q = {
              id: bank[i].id,
              title: bank[i].text,
              img: bank[i].media,
              level: bank[i].level,
              lesson: bank[i].lessonName,
              lessonId: bank[i].lessonId,
              grade: bank[i].gradeName,
              gradeId: bank[i].gradeId,
              field: this.sayFieldName(bank[i].field),
              isTest: bank[i].type === 1,
            };
            this.examQuestions.push(q);
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getLessons(f) {
      this.lessons = ['لطفا صبر کنید'];
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.lessons = [];
          const arr = response.data.data;
          for (let i = 0; i < arr.length; i += 1) {
            this.lessons.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
          // console.warn(this.lessons);
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    selected(e, dropDown) {
      // console.log(e, dropDown);
      switch (dropDown) {
        case 'field': {
          if (e.id !== '' && e.id !== undefined) {
            // console.warn(e.id);
            // console.log('رشته انتخاب شد');
            this.getGrades(e.id);
            this.fFieldIdErr = false;
            this.fGradeErr = true;
            this.fLessonErr = true;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.fFieldIdErr = true;
          }
          this.fGradeErr = true;
          this.fLessonErr = true;
          // ریست کردن لیست ها
          this.grades = [{
            title: 'رشته را انتخاب کنید',
            id: '',
          }];
          this.filterGrade = {};
          this.lessons = [{
            title: 'رشته و پایه را انتخاب کنید',
            id: '',
          }];
          this.filterLesson = {};
          break;
        }
        case 'grade': {
          if (e.id !== '' && e.id !== undefined) {
            // console.warn(e.id);
            // console.log('پایه انتخاب شد');
            this.getLessons(e.id);
            this.fGradeErr = false;
            this.fLessonErr = true;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.fGradeErr = true;
            this.fLessonErr = true;
            // ریست کردن لیست ها
            this.lessons = [{
              title: 'پایه را انتخاب کنید',
              id: '',
            }];
            this.filterLesson = {};
            this.filterGrade = {};
          }
          break;
        }
        case 'lesson': {
          if (e.id !== '' && e.id !== undefined) {
            // console.warn(e.id);
            // console.log('درس انتخاب شد');
            this.fLessonErr = false;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.fLessonErr = true;
            // ریست کردن لیست ها
            this.lessons = [{
              title: 'پایه را انتخاب کنید',
              id: '',
            }];
            this.filterLesson = {};
          }
          break;
        }
        default:
          break;
      }
    },
    clearSelected() {
      this.examQuestions = [];
    },
    deleteQuestion(id) {
      if (this.findInArray(id) !== -1) {
        this.examQuestions.splice(this.findInArray(id), 1);
      }
    },
    findInArray(id) {
      let ind = -1;
      for (let i = 0; i < this.examQuestions.length; i += 1) {
        if (this.examQuestions[i].id === id) {
          ind = i;
        }
      }
      return ind;
    },
    calcStartEnd() {
      if (this.examDate !== '') {
        this.eDateErr = false;
        // eslint-disable-next-line
        this.examDateShow = moment(this.examDate, 'YYYY-MM-DDTHH:mm').locale('FA').format('jDD jMMMM jYY، HH:mm');
        this.examStartAt = this.examDate;
        this.examEndAt = moment(this.examStartAt, 'YYYY-MM-DDTHH:mm')
          .add(this.examDuration, 'minutes')
          .format('YYYY-MM-DDTHH:mm');
        this.endAtShow = moment(this.examStartAt, 'YYYY-MM-DDTHH:mm')
          .add(this.examDuration, 'minutes')
          .format('HH:mm');
      } else {
        this.eDateErr = true;
        this.examStartAt = '';
        this.examEndAt = '';
      }
      // console.error(this.examStartAt);
      // console.error(this.examEndAt);
    },
    sayFieldName(num) {
      let sfn = '';
      switch (num) {
        case 0: {
          sfn = 'متوسطه‌ی اول';
          break;
        }
        case 1: {
          sfn = 'ریاضی فیزیک';
          break;
        }
        case 2: {
          sfn = 'علوم تجربی';
          break;
        }
        case 3: {
          sfn = 'انسانی';
          break;
        }
        case 4: {
          sfn = 'فنی';
          break;
        }
        case 5: {
          sfn = 'هنر';
          break;
        }
        case 6: {
          sfn = 'زبان';
          break;
        }
        default:
          break;
      }
      return sfn;
    },
    newExam() {
      if (this.isFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Exams`;
        // type
        let eType = 0;
        if (this.examIsSync) {
          eType = 1;
        } else {
          eType = 2;
        }
        // is random question?
        let eArrange = 0;
        if (this.examIsRandomQuestion) {
          eArrange = 2;
        } else {
          eArrange = 1;
        }
        // start at
        let startAt = '';
        if (this.examStartAt === '') {
          startAt = null;
        } else {
          startAt = this.examStartAt;
        }
        // lesson id
        let lid = '';
        if (this.fLessonErr) {
          lid = null;
        } else {
          lid = this.examLesson.id;
        }
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            title: this.examName,
            description: this.examDesc,
            hasTime: this.examSkipOnTime,
            gradeId: this.examGrade.id,
            field: this.examField.id,
            lessonId: lid,
            examType: eType,
            arrangeQuestion: eArrange,
            participateTest: parseInt(this.examHowManyTimes, 10),
            periodOfTime: parseInt(this.examDuration, 10),
            dateOfExam: startAt,
            questions: this.generateQuestions(),
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            // console.warn(response.data.data);
            this.clearExam();
            this.makeToast('success', 'آزمون جدید با موفقیت ثبت شد', 3000);
          } else {
            this.responseFalse = true;
            this.makeToast('success', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          // console.log(error);
        });
      }
    },
    editExam() {
      if (this.isFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Exams/${this.init.id}`;
        // type
        let eType = 0;
        if (this.examIsSync) {
          eType = 1;
        } else {
          eType = 2;
        }
        // is random question?
        let eArrange = 0;
        if (this.examIsRandomQuestion) {
          eArrange = 2;
        } else {
          eArrange = 1;
        }
        // start at
        let startAt = '';
        if (this.examStartAt === '') {
          startAt = null;
        } else {
          startAt = this.examStartAt;
        }
        // lesson id
        let lid = '';
        if (this.fLessonErr) {
          lid = null;
        } else {
          lid = this.examLesson.id;
        }
        const datas = {
          title: this.examName,
          description: this.examDesc,
          hasTime: this.examSkipOnTime,
          gradeId: this.examGrade.id,
          lessonId: lid,
          examType: eType,
          arrangeQuestion: eArrange,
          field: this.examField.id,
          participateTest: parseInt(this.examHowManyTimes, 10),
          periodOfTime: parseInt(this.examDuration, 10),
          dateOfExam: startAt,
          questions: this.generateQuestions(),
        };
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: datas,
        }).then((response) => {
          if (response.data.isSuccess) {
            // console.warn(response.data.data);
            this.clearExam();
            this.makeToast('success', 'آزمون با موفقیت ویرایش شد', 3000);
            EventBus.$emit('editDone');
          } else {
            this.responseFalse = true;
            this.makeToast('success', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          // console.log(error);
        });
      }
    },
    clearExam() {
      this.clearSelected();
      this.fields = [
        {
          id: '',
          title: 'حذف فیلتر',
        },
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'زبان',
        },
        {
          id: 6,
          title: 'هنر',
        },
      ];
      this.fFieldIdErr = true;
      this.grades = [
        {
          id: '',
          title: 'لطفا رشته را انتخاب کنید',
        },
      ];
      this.fGradeErr = true;
      this.lessons = [
        {
          id: '',
          title: 'ابتدا رشته را انتخاب کنید',
        },
      ];
      this.fLessonErr = true;
      this.filterLesson = '';
      // add exam
      this.examName = '';
      this.eNameErr = true;
      this.eNameLen = 112;
      this.examIsSync = false;
      this.examField = '';
      this.eField = 0;
      this.eFieldErr = true;
      this.examGrade = '';
      this.eGrade = '';
      this.isGradesLoaded = false;
      this.eGradeErr = true;
      this.examDate = '';
      this.examDateShow = '';
      this.eDateErr = true;
      this.examStartAt = '';
      this.eStartAtErr = true;
      this.examEndAt = '';
      this.eEndAtErr = true;
      this.endAtShow = '';
      this.examLesson = '';
      this.examDuration = 5;
      this.examHowManyTimes = 1;
      this.examIsRandomQuestion = false;
      this.examSkipOnTime = false;
      this.examDesc = '';
      this.eDescLen = 512;
      this.eDescErr = true;
      this.examQuestions = [];
      this.eQuestionIds = [];
      this.examActiveNumbering = false;
    },
    generateQuestions() {
      this.eQuestionIds = [];
      if (this.examQuestions.length > 0) {
        for (let i = 0; i < this.examQuestions.length; i += 1) {
          // console.log(document.getElementById(`qIndex${i}`).value);
          const t = {
            questionId: this.examQuestions[i].id,
            order: parseInt(document.getElementById(`qIndex${i}`).value, 10),
          };
          this.eQuestionIds.push(t);
        }
      }
      return this.eQuestionIds;
    },
    updateQuestionList(e) {
      this.examQuestions = e;
    },
    initMode() {
      // console.log(this.mode);
      if (this.mode === 'edit') {
        // set datas
        const data = this.init;
        this.examName = data.title;
        this.examDuration = data.periodOfTime;
        if (data.examType === 1) {
          this.examDate = data.dateOfExam;
          this.examIsSync = true;
        } else {
          this.examDate = '';
          this.examIsSync = false;
        }
        if (data.arrangeQuestion === 1) {
          this.examIsRandomQuestion = false;
        } else {
          this.examIsRandomQuestion = true;
        }
        // field
        this.examField = {
          id: data.field,
          title: this.sayFieldName(data.field),
        };
        this.fFieldIdErr = false;
        // grade
        this.examGrade = {
          id: data.gradeId,
          title: data.gradeName,
        };
        this.fGradeErr = false;
        // lesson
        if (data.lessonId !== null) {
          this.examLesson = {
            id: data.lessonId,
            title: data.lessonName,
          };
          this.fLessonErr = false;
        } else {
          this.fLessonErr = true;
        }
        this.examSkipOnTime = data.hasTime;
        this.examHowManyTimes = data.participateTest;
        this.examDesc = data.description;
        // get exam questions
        this.getExamQuestions();
      }
    },
    calcIsolateMode(command) {
      switch (command) {
        case 'on': {
          this.isolateMode = true;
          this.examActiveNumbering = true;
          EventBus.$emit('disableAdd');
          break;
        }
        case 'off': {
          this.isolateMode = false;
          this.examActiveNumbering = false;
          EventBus.$emit('enableAdd');
          break;
        }
        default:
          break;
      }
    },
  },
  computed: {
    isFormReady() {
      if (this.examIsSync) {
        return !this.fFieldIdErr
          && !this.fGradeErr
          && !this.eNameErr
          && !this.eDateErr
          && this.examQuestions.length > 0;
      }
      return !this.fFieldIdErr
        && !this.fGradeErr
        && !this.eNameErr
        && this.examQuestions.length > 0;
    },
    showNextStep() {
      return (!this.examActiveNumbering && this.examIsRandomQuestion) || this.examIsRandomQuestion;
    },
    readyToGo() {
      const a = this.examActiveNumbering || this.examIsRandomQuestion;
      return a;
    },
  },
  watch: {
    examDuration() {
      if (this.examDuration > 999) {
        this.examDuration = 999;
      } else if (this.examDuration < 5) {
        this.examDuration = 5;
      }
      if (this.examIsSync) {
        this.calcStartEnd();
      }
    },
    examHowManyTimes() {
      if (this.examHowManyTimes < 1) {
        this.examHowManyTimes = 1;
      }
      if (this.examHowManyTimes > 1000) {
        this.examHowManyTimes = 1000;
      }
    },
    examName() {
      if (this.examName.length > this.eNameLen) {
        this.examName = this.examName.slice(0, this.eNameLen);
        this.eNameErr = false;
      } else if (this.examName.length > 0) {
        this.eNameErr = false;
      } else if (this.examName === '') {
        this.eNameErr = true;
      }
    },
    examIsSync() {
      if (this.examIsSync) {
        this.examHowManyTimes = 1;
        if (this.examDate === '') {
          this.eDateErr = true;
        } else {
          this.eDateErr = false;
        }
      } else {
        this.examDate = '';
      }
    },
    examDate() {
      this.calcStartEnd();
    },
    examIsRandomQuestion() {
      // if (this.examIsRandomQuestion) {
      //   this.examActiveNumbering = true;
      // } else {
      //   this.examActiveNumbering = false;
      // }
      // console.log(this.examIsRandomQuestion);
      // به ترتیب true | تصادفی false
    },
    examQuestions() {
      // console.log(this.examQuestions);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getFields();
      window.katex = katex;
      this.today = moment(new Date()).format('YYYY-MM-DD');
      this.initMode();
    });
    // EventBus.$on('clearSelected', () => {
    //   console.warn('clear selected question');
    // });
    // EventBus.$on('updateSelectedClass', (e) => {
    //   this.examQuestions = e;
    //   console.warn('updateSelectedClass');
    // });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/new.scss';

  .addQuestion {
    padding-left: 16px;
    h2 {
      font-weight: 200;
      font-size: 24px;
      padding-bottom: 16px;
      border-bottom: 1px dashed rgba($color: #000000, $alpha: 0.15);
      margin-bottom: 16px;
      color: rgba($color: #4e6086, $alpha: 1.0);
      i {
        margin-left: 8px;
        font-size: 24px;
      }
    }
    .disabled {
      cursor: pointer;
      pointer-events: none;
      opacity: 0.25;
    }
    .isTrueCheckBox {
      width: 24px;
      height: 24px;
      color: gray;
      padding: 8px;
      border-radius: 50%;
      margin-left: 8px;
      border: solid 2px gray;
      border-radius: 4px;
      position: relative;
      cursor: pointer;
      * {
        pointer-events: none;
      }
      .tick {
        position: absolute;
        width: 0px;
        top: 8px;
        left: 8px;
        height: 0px;
        border: solid 4px rgb(223, 223, 223);
        border-top: none;
        border-left: none;
        transform: rotate(45deg);
      }
    }
    .isTrueCheckBox:hover {
      border-color: rgb(30, 63, 30);
    }
    .isTrueCheckBox.selected {
      border-color: rgb(30, 63, 30);
      .tick {
        border-color: green;
        width: 12px;
        top: -8px;
        left: 8px;
        height: 24px;
      }
    }
    .previewInfos {
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 10px;
      label {
        margin: 12px 0 0;
        padding: 4px 8px;
        border-radius: 8px;
        background-color: rgba($color: #000000, $alpha: 0.15);
      }
      .openEditor {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: teal;
        opacity: 0;
        cursor: pointer;
        * {
          pointer-events: none;
        }
        i {
          font-size: 48;
          margin-bottom: 8px;
          color: rgb(255, 255, 255);
        }
        .dialog {
          font-size: 14px;
          font-weight: 100;
          color: white;
        }
      }
    }
    .previewInfos:hover {
      .openEditor {
        opacity: 0.85;
      }
    }
    .noQ {
      height: 112px;
      padding-right: 16px;
      margin-right: 2px;
      border-right: solid 2px rgba($color: #000000, $alpha: 0.15);
      span {
        font-size: 16px;
        font-weight: 100;
        color: gray;
      }
      span.m {
        font-size: 12px;
        font-weight: 300;
        color: gray;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-height: 350px;
      border-radius: 8px;
      border: solid 1px rgba($color: #000000, $alpha: 0.05);
      overflow: hidden auto;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: bold;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
          .qOptions {
            p {
              font-size: 12px;
              text-align: right;
              margin-top: 8px;
              font-weight: bold;
            }
          }
        }
        @keyframes inp {
          0% {
            box-shadow: 0 0 0 0 rgba($color: #000000, $alpha: 0.25);
          }
          100% {
            box-shadow: 0 0 0 16px rgba($color: #000000, $alpha: 0.0);
          }
        }
        input[type='number'] {
          width: 32px;
          text-align: center;
          border-radius: 8px;
          border: solid 2px rgba($color: #000000, $alpha: 0.1);
          animation: inp 2s cubic-bezier(1, 0, 0, 1) infinite;
          margin-left: 8px;
        }
        input[type='number']:disabled {
          width: 32px;
          text-align: center;
          border-radius: 8px;
          border: solid 2px rgba($color: #000000, $alpha: 0.0);
          animation: none;
          margin-left: 8px;
        }
      }
      li.selected {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.02);
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
</style>
